import { EventTypes, liveChatRepository } from '@leagueplatform/live-chat';

export const terminateLiveChatSession = () => {
  liveChatRepository.sendUserEvent({
    type: EventTypes.END_CHAT,
    eventId: crypto.randomUUID(),
  });
};
